<template>
  <div id="app">
    <gpHeader/>
    <router-view  class="animate__animated animate__fadeIn" />
    <gpFooter class="gp-footer"/>
  </div>
</template>

<script>
import gpHeader from "../src/components/gp-header.vue";
import gpFooter from "../src/components/gp-footer.vue";
export default {
  name: 'App',
  data() {
    return {
      headerIsShow:true,
      headerShowActionLock:false
    }
  },
  components: {
    gpHeader,
    gpFooter
  },
  mounted(){
  },
  methods: {
  }
}

</script>

<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.router-view{
  width: 100%;
  height: auto;
  position: absolute;
  top: 0;
  bottom: 0;
  margin: 0 auto;
  -webkit-overflow-scrolling: touch;
}
.gp-footer{
  width: 100%;
  box-sizing: border-box !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue